// Constants for public marketing pages. No fake claims — only user-provided facts.
export const SITE = {
  url: "https://registryfeed.com",
  brand: "Registry Feed",
  legalName: "Registry Feed",
  salesEmail: "sales@registryfeed.com",
  whatsappNumber: "918537942196", // international format without +
  whatsappDisplay: "+91 85379 42196",
};

export const WA_MESSAGES = {
  mca: "Hi, I want to buy MCA data. Please share pricing and details.",
  gst: "Hi, I want to buy GST data. Please share pricing and details.",
  new: "Hi, I want to buy New Company Data. Please share pricing and details.",
  sample: "Hi, I want to request a sample/trial of your data. Please share the available options.",
  general: "Hi, I want to buy your MCA/GST database. Please share pricing and details.",
};

export function waLink(msg) {
  return `https://wa.me/${SITE.whatsappNumber}?text=${encodeURIComponent(msg)}`;
}

// Facts provided by the business — never invent beyond this list.
export const COVERAGE_FACTS = [
  "All 36 Indian states and union territories",
  "All ROC (Registrar of Companies) jurisdictions",
  "Both GST and MCA registrations",
  "Daily uploads of newly registered companies",
  "30-day access per subscription window",
];

export const PRICING = {
  mca: { price: 21999, period: "month", label: "MCA Company Database" },
  gst: { price: 29999, period: "month", label: "GST Company Database" },
  trial: { price: 3000, period: "3 days", label: "Pan India Trial" },
  stateWise: { label: "State-wise Package", note: "Contact on WhatsApp for pricing" },
};
